import type { DnDItem } from '@repo/foundations/components/DnD/types';

export const generateMetricsLayout = <T>(metrics: DnDItem<T>[]) =>
	metrics.reduce((acc, metric, index) => {
		const row = Math.floor(index / 3) + 1;
		const order = (index % 3) + 1;
		return {
			...acc,
			[metric.id]: {
				row,
				order,
			},
		};
	}, {});
